import { apiClient } from './api'

export type RecycleBinEntityType =
  | 'project'
  | 'task'
  | 'portfolio'
  | 'program'
  | 'department'
  | 'team'

export interface RecycleBinItem {
  entity_type: RecycleBinEntityType
  id: number
  name: string
  description: string | null
  deleted_at: string | null
  restore_path: string
  parent: { id: number; attr: string } | null
}

export const recycleBinService = {
  list: (entityType?: RecycleBinEntityType) =>
    apiClient
      .get<RecycleBinItem[]>('/api/v1/recycle-bin', {
        params: entityType ? { entity_type: entityType } : {},
      })
      .then(r => r.data),

  restore: (path: string) => apiClient.post(path),
}
